import React from "react";
import Header from "./components/Header";
import Users from "./components/Users";
import AddUser from "./components/AddUser";
import axios from "axios";

const baseUrl = 'https://reqres.in/api/users?page=1';

class  App extends React.Component {

    constructor(props) {
    super(props)
        axios.get(baseUrl, {
            headers: {
            "x-api-key": "reqres_db611697d2b04affb9f512591c6dd464"
            }
        }).then((res) => { this.setState({users: res.data.data})})

    this.state = {
        users: [],
        isFormOpen: false
    }
    this.addUser = this.addUser.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
    this.editUser = this.editUser.bind(this);
    this.toggleForm = this.toggleForm.bind(this);
    }

    render() {
        return (<div>
            <Header title='User list' onToggleForm={this.toggleForm} />
            <main>
                <Users users={this.state.users} onEdit={this.editUser} onDelete={this.deleteUser}/>
            </main>
            <aside className={this.state.isFormOpen ? "open" : "close"}>
                <AddUser Add={this.addUser} onToggleForm={this.toggleForm} />
            </aside>
        </div> )
    }

    toggleForm() {
        this.setState(prevState => ({
            isFormOpen: !prevState.isFormOpen
        }))
    }

    editUser(user) {
        let allUsers = this.state.users;
        allUsers[user.id - 1] = user;

        this.setState({users: []}, () => {
            this.setState({users: [...allUsers]})
        })
    }

    deleteUser(id) {
        this.setState({
            users: this.state.users.filter((el) => el.id !== id)
        }
        )
    }
    
    addUser(user) {
        const id = this.state.users.length + 1;
        this.setState({users: [...this.state.users, {id, ...user}]}) 
    }
}

export default App